export const todos = [
  {
    isCompleted: true,
    todoText: "Complete online Javascript course",
    id: 1608952242840,
  },
  { isCompleted: false, todoText: "Jog around the park 3x", id: 1608952275374 },
  { isCompleted: false, todoText: "10 minutes meditation", id: 1608952290501 },
  { isCompleted: false, todoText: "Read for 1 hour", id: 1608952304429 },
  { isCompleted: false, todoText: "Pick up groceries", id: 1608952316708 },
  {
    isCompleted: false,
    todoText: "Complete Todo App on Frontend Mentor",
    id: 1608952342380,
  },
];
